// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

// Constants for PDP

/*
  UMD header generated via modularize.js at 2015-04-02T17:19:27.262Z
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:constants': []
})(this, function (m_module) {
"use strict";
var M = m_module.M;

M.Model = M.Model || {};
M.Model.ProductDetails = M.Model.ProductDetails || {};

// Paper Tier Options
// Keep this list in sync with src/js/cu3/constants.js
M.Model.ProductDetails.SIGNATURE = 5;
M.Model.ProductDetails.PEARLESCENT = 7;
M.Model.ProductDetails.RECYCLED_PAPER = 20;
M.Model.ProductDetails.STRATHMORE = 11;
M.Model.ProductDetails.ONE_TEN_MATT_COVER_STOCK = 38;
M.Model.ProductDetails.CALENDAR_PAPER = 40;
M.Model.ProductDetails.NOTEBOOK_BLANK = 45;
M.Model.ProductDetails.NOTEBOOK_LINED = 46;
M.Model.ProductDetails.NOTEBOOK_GRAPH = 48;
M.Model.ProductDetails.COVER_STOCK = 47;
M.Model.ProductDetails.COTTON_RAG = 49;
M.Model.ProductDetails.TRIPLE_THICK = 50;
M.Model.ProductDetails.MUSEUM_BOARD = 53;
M.Model.ProductDetails.MAGNET = 55;
M.Model.ProductDetails.SOMERSET_500 = 56;
M.Model.ProductDetails.COVENTRY_320 = 57;
M.Model.ProductDetails.SOMERSET_320 = 58;
M.Model.ProductDetails.POLY = 59;
M.Model.ProductDetails.CANVAS = 59;
M.Model.ProductDetails.DOUBLE_THICK = 61;
M.Model.ProductDetails.DELUXE_ART = 62;
M.Model.ProductDetails.WRAPPING_PAPER = 63;
M.Model.ProductDetails.SIGNATURE80 = 70;
M.Model.ProductDetails.SMOOTH_SIGNATURE = 107;
M.Model.ProductDetails.PREMIUM_MATTE_ADHESIVE_FABRIC = 113;
// Fabric kinds
M.Model.ProductDetails.COTTON_CANVAS_TOPANGA = 71;
M.Model.ProductDetails.COTTON_CANVAS_65 = 72;
M.Model.ProductDetails.COTTON_CANVAS_10 = 73;
M.Model.ProductDetails.COTTON_DUCK = 74;
// Digital kinds
M.Model.ProductDetails.DIGITAL_PAPER = 75;
// Sticker kinds
M.Model.ProductDetails.UNCOATED_STICKER = 77;
M.Model.ProductDetails.WATERPROOF_LABEL = 78;
// Digital Letterpress
M.Model.ProductDetails.SAVOY_BRIGHT_WHITE = 79;
// Home Decor
M.Model.ProductDetails.LIGHTWEIGHT_COTTON_SHEETING = 80;
M.Model.ProductDetails.PREMIUM_COTTON = 81;
M.Model.ProductDetails.LUXURY_LINEN = 82;
M.Model.ProductDetails.LUXURY_LIGHTWEIGHT_LINEN = 83;
// Stamps
M.Model.ProductDetails.ADHESIVE_POSTAGE_PAPER = 87;
// Vellum
M.Model.ProductDetails.VELLUM = 91;
//Art Shelving
M.Model.ProductDetails.WOODEN_WALL_SHELF = 96;
M.Model.ProductDetails.WHITEWASH_FARMHOUSE_WOOD = 97;
M.Model.ProductDetails.WHITEWASH_HERRINGBONE_WOOD = 98;
M.Model.ProductDetails.PREMIUM_WOOD = 99;
M.Model.ProductDetails.NATURAL_WOOD = 100;
M.Model.ProductDetails.METAL = 101;
// Belly Bands
M.Model.ProductDetails.SIGNATURETEXT_100 = 111;
// AIO Budget Paper
M.Model.ProductDetails.VALUE_COVER = 114;

M.Model.ProductDetails.RECYCLED_SMOOTH_SIGNATURE = 120;
M.Model.ProductDetails.RECYCLED_100 = 122;

M.Model.ProductDetails.RECYCLED_PAPERS = [
  M.Model.ProductDetails.RECYCLED_PAPER,
  M.Model.ProductDetails.TRIPLE_THICK,
  M.Model.ProductDetails.DOUBLE_THICK,
  M.Model.ProductDetails.RECYCLED_SMOOTH_SIGNATURE
];

// TODO: rename PAPER_OPTION_LABELS to PAPER_OPTION_LABELS_HTML
// to reflect the fact that it should not be HTML escaped
M.Model.ProductDetails.PAPER_OPTION_LABELS = {};
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.SIGNATURE] = 'Signature Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.RECYCLED_PAPER] = 'Premium 100% Recycled Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.ONE_TEN_MATT_COVER_STOCK] = '110 lb. matte cover stock';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.PEARLESCENT] = 'Pearlescent Paper';
// TODO: Remove Strathmore and change all of its references
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.STRATHMORE] = 'Signature Cover Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.COVER_STOCK] = 'Cover Stock';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.COTTON_RAG] = 'Premium Art Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.TRIPLE_THICK] = 'TripleThick&trade; Paper - NEW!';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.MUSEUM_BOARD] = 'Luxe Museum Board - NEW!';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.MAGNET] = 'Magnet Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.SOMERSET_500] = 'Premium 100% Cotton Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.COVENTRY_320] = '100% Cotton Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.SOMERSET_320] = 'Cotton Rag';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.POLY] = 'Poly';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.CANVAS] = 'Canvas';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.DOUBLE_THICK] = 'DoubleThick Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.SMOOTH_SIGNATURE] = 'Smooth Signature Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.DELUXE_ART] = 'Standard Art Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.WRAPPING_PAPER] = 'Premium Gift Wrap';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.SIGNATURE80] = '80lb. Signature Paper';

M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.COTTON_CANVAS_TOPANGA] = 'Classic Cotton Canvas';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.COTTON_CANVAS_65] = 'Linen-Cotton Blend';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.COTTON_CANVAS_10] = 'Heavy Canvas';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.COTTON_DUCK] = 'Heavy Cotton Duck';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.DIGITAL_PAPER] = 'Digital Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.UNCOATED_STICKER] = 'Uncoated Sticker Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.WATERPROOF_LABEL] = 'Waterproof Sticker Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.SAVOY_BRIGHT_WHITE] = 'Luxury Cotton Paper';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.VELLUM] = 'Translucent Vellum';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.PREMIUM_MATTE_ADHESIVE_FABRIC] = 'Premium Matte Self-Adhesive Material';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.VALUE_COVER] = 'Value Cover';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.RECYCLED_SMOOTH_SIGNATURE] = 'Smooth Signature Paper';

// Home Decor
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.PREMIUM_COTTON] = 'Premium Cotton';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.LUXURY_LINEN] = 'Luxury Linen';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.LUXURY_LIGHTWEIGHT_LINEN] = 'Luxury Lightweight Linen';
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.LIGHTWEIGHT_COTTON_SHEETING] = 'Lightweight Cotton Sheeting';

// Stamps
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.ADHESIVE_POSTAGE_PAPER] = 'Adhesive Postage Paper';

// Belly Bands
M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.SIGNATURETEXT_100] = 'Signature Text';

M.Model.ProductDetails.PAPER_OPTION_LABELS[
  M.Model.ProductDetails.RECYCLED_100] = 'Recycled Text';

// Paper Options sorted by price
M.Model.ProductDetails.PAPER_OPTIONS = [
  M.Model.ProductDetails.ONE_TEN_MATT_COVER_STOCK,
  M.Model.ProductDetails.SMOOTH_SIGNATURE,
  M.Model.ProductDetails.PREMIUM_MATTE_ADHESIVE_FABRIC,
  M.Model.ProductDetails.SIGNATURE,
  M.Model.ProductDetails.STRATHMORE,
  M.Model.ProductDetails.RECYCLED_PAPER,
  M.Model.ProductDetails.PEARLESCENT,
  M.Model.ProductDetails.UNCOATED_STICKER,
  M.Model.ProductDetails.WATERPROOF_LABEL,
  M.Model.ProductDetails.MAGNET,
  M.Model.ProductDetails.DOUBLE_THICK,
  M.Model.ProductDetails.TRIPLE_THICK,
  M.Model.ProductDetails.MUSEUM_BOARD,
  M.Model.ProductDetails.COVER_STOCK,
  M.Model.ProductDetails.COTTON_RAG,
  M.Model.ProductDetails.COVENTRY_320,
  M.Model.ProductDetails.SOMERSET_500,
  M.Model.ProductDetails.SOMERSET_320,
  M.Model.ProductDetails.CALENDAR_PAPER,
  M.Model.ProductDetails.POLY, // This may change, TBD
  M.Model.ProductDetails.CANVAS, // This may change, TBD
  M.Model.ProductDetails.DELUXE_ART,
  M.Model.ProductDetails.WRAPPING_PAPER,
  M.Model.ProductDetails.SIGNATURE80,
  M.Model.ProductDetails.COTTON_CANVAS_TOPANGA,
  M.Model.ProductDetails.COTTON_CANVAS_65,
  M.Model.ProductDetails.COTTON_CANVAS_10,
  M.Model.ProductDetails.COTTON_DUCK,
  M.Model.ProductDetails.DIGITAL_PAPER,
  M.Model.ProductDetails.SAVOY_BRIGHT_WHITE,
  M.Model.ProductDetails.PREMIUM_COTTON,
  M.Model.ProductDetails.LUXURY_LINEN,
  M.Model.ProductDetails.LUXURY_LIGHTWEIGHT_LINEN,
  M.Model.ProductDetails.ADHESIVE_POSTAGE_PAPER,
  M.Model.ProductDetails.VELLUM,
  M.Model.ProductDetails.SIGNATURETEXT_100,
  M.Model.ProductDetails.VALUE_COVER,
  M.Model.ProductDetails.RECYCLED_SMOOTH_SIGNATURE
];

M.Model.ProductDetails.HOME_DECOR_PAPER_OPTIONS_DISPLAY_ORDER = [
  M.Model.ProductDetails.LIGHTWEIGHT_COTTON_SHEETING,
  M.Model.ProductDetails.COTTON_CANVAS_TOPANGA,
  M.Model.ProductDetails.COTTON_CANVAS_65,
  M.Model.ProductDetails.PREMIUM_COTTON,
  M.Model.ProductDetails.LUXURY_LINEN,
  M.Model.ProductDetails.LUXURY_LIGHTWEIGHT_LINEN
]

// Format Tier Options sorted by price
M.Model.ProductDetails.FORMAT_OPTIONS = [
  M.FormatOptions.FLAT,
  M.FormatOptions.FOLDED_BLANK,
  M.FormatOptions.FOLDED_TEXT,
  M.FormatOptions.CALENDAR,
  M.FormatOptions.MINIBOOK_A,
  M.FormatOptions.MINIBOOK_B,
  M.FormatOptions.LINED_NOTEBOOK,
  M.FormatOptions.ADDRESS_BOOK_NOTEBOOK,
  M.FormatOptions.MONTHLY_PLANNER_NOTEBOOK,
  M.FormatOptions.WEEKLY_PLANNER_NOTEBOOK,
  M.FormatOptions.BOOKLETTE_A,
  M.FormatOptions.BOOKLETTE_B,
  M.FormatOptions.DIGITAL_INVITATION,
  M.FormatOptions.LARGE_CUSTOM_WEDDING_SIGN,
  M.FormatOptions.ONE_OUNCE_STAMP,
  M.FormatOptions.TWO_OUNCE_STAMP,
  M.FormatOptions.POSTCARD_STAMP,
  M.FormatOptions.ALL_IN_ONE
];

// Format Labels
M.Model.ProductDetails.FORMAT_OPTION_LABELS = {};
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.FLAT] = 'Flat Card';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.FOLDED_BLANK] = 'Folded Card';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.FOLDED_TEXT] = 'Folded Card';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.YEARLINE] = 'Folded Card';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.CALENDAR] = 'Calendar';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.MINIBOOK_A] = 'Minibook A';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.MINIBOOK_B] = 'Minibook B';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.LINED_NOTEBOOK] = 'Journal';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.MONTHLY_PLANNER_NOTEBOOK] = 'Monthly Planner';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.WEEKLY_PLANNER_NOTEBOOK] = 'Weekly Planner';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.ADDRESS_BOOK_NOTEBOOK] = 'Address Book';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.ONE_OUNCE_STAMP] = 'First Class 1 oz Letter';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.TWO_OUNCE_STAMP] = 'First Class 2 oz / Square Letter';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.POSTCARD_STAMP] = 'Postcard First Class';
M.Model.ProductDetails.FORMAT_OPTION_LABELS[
  M.FormatOptions.ALL_IN_ONE] = 'All-in-One';


// List the format options that should be displayed on the PDP.
M.Model.ProductDetails.FORMAT_OPTIONS_FOR_PDP = [
  M.FormatOptions.FLAT,
  M.FormatOptions.FOLDED_BLANK,
  M.FormatOptions.FOLDED_TEXT,
  M.FormatOptions.YEARLINE,
  M.FormatOptions.CALENDAR,
  M.FormatOptions.MINIBOOK_A,
  M.FormatOptions.MINIBOOK_B,
  M.FormatOptions.LINED_NOTEBOOK,
  M.FormatOptions.MONTHLY_PLANNER_NOTEBOOK,
  M.FormatOptions.WEEKLY_PLANNER_NOTEBOOK,
  M.FormatOptions.ADDRESS_BOOK_NOTEBOOK,
  M.FormatOptions.BOOKLETTE_A,
  M.FormatOptions.BOOKLETTE_B,
  M.FormatOptions.ONE_OUNCE_STAMP,
  M.FormatOptions.TWO_OUNCE_STAMP,
  M.FormatOptions.POSTCARD_STAMP,
  M.FormatOptions.ALL_IN_ONE
];

M.Model.ProductDetails.OPTION = {
  FORMAT: 'FORMAT',
  PRODUCT: 'PRODUCT',
  BINDING: 'BINDING',
  ENVELOPE_COLOR: 'ENVELOPE_COLOR',
  PAPER: 'PAPER',
  FABRIC: 'FABRIC',
  DIE_CUT: 'DIE_CUT',
  STAMP_DENOMINATION: 'STAMP_DENOMINATION'
};

M.Model.ProductDetails.OPTION_ORDER = [
  M.Model.ProductDetails.OPTION.FORMAT,
  M.Model.ProductDetails.OPTION.PRODUCT,
  M.Model.ProductDetails.OPTION.BINDING,
  M.Model.ProductDetails.OPTION.PAPER,
  M.Model.ProductDetails.OPTION.ENVELOPE_COLOR,
  M.Model.ProductDetails.OPTION.FABRIC,
  M.Model.ProductDetails.OPTION.DIE_CUT,
  M.Model.ProductDetails.OPTION.STAMP_DENOMINATION
];

M.Model.ProductDetails.OPTIONS = M.Model.ProductDetails.OPTIONS || {};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.FORMAT] = {
  aboutDescription: 'about our unique formats',
  trackEventAction: "M.GA.TRACK_EVENT_ACTION.ABOUT_FORMATS_CLICK",
  header: 'Choose Format',
  cssPrefix: 'format',
  notTBLTBF: true
};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.PAPER] = {
  aboutDescription: 'about our paper',
  trackEventAction: "M.GA.TRACK_EVENT_ACTION.ABOUT_PAPERS_CLICK",
  header: 'Choose Paper',
  cssPrefix: 'paper'
};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.FABRIC] = {
  aboutDescription: 'about our fabric',
  trackEventAction: "M.GA.TRACK_EVENT_ACTION.ABOUT_FABRICS_CLICK",
  header: 'Choose Fabric Type',
  cssPrefix: 'paper'
};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.BINDING] = {
  header: 'Choose Binding',
  cssPrefix: 'binding'
};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.ENVELOPE_COLOR] = {
  header: 'Choose Envelope Color',
  cssPrefix: 'envelope'
};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.PRODUCT] = {
  header: 'Choose Product',
  cssPrefix: 'product'
};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.DIE_CUT] = {
  header: 'Die Cut Shape',
  cssPrefix: 'shape'
};
M.Model.ProductDetails.OPTIONS[M.Model.ProductDetails.OPTION.STAMP_DENOMINATION] = {
  header: 'Choose Postage Value',
  cssPrefix: 'format'
}

return {
};

});
